import type { ComponentProps } from 'react';

const Exclaimation = (props: ComponentProps<'svg'>) => {
  const { fill = '#8C98AB', ...rest } = props;
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_3622_10720)">
        <g clipPath="url(#clip1_3622_10720)">
          <g clipPath="url(#clip2_3622_10720)">
            <path
              d="M32 17.375C35.8788 17.375 39.5987 18.9158 42.3414 21.6586C45.0842 24.4013 46.625 28.1212 46.625 32C46.625 35.8788 45.0842 39.5987 42.3414 42.3414C39.5987 45.0842 35.8788 46.625 32 46.625C28.1212 46.625 24.4013 45.0842 21.6586 42.3414C18.9158 39.5987 17.375 35.8788 17.375 32C17.375 28.1212 18.9158 24.4013 21.6586 21.6586C24.4013 18.9158 28.1212 17.375 32 17.375ZM32 50C36.7739 50 41.3523 48.1036 44.7279 44.7279C48.1036 41.3523 50 36.7739 50 32C50 27.2261 48.1036 22.6477 44.7279 19.2721C41.3523 15.8964 36.7739 14 32 14C27.2261 14 22.6477 15.8964 19.2721 19.2721C15.8964 22.6477 14 27.2261 14 32C14 36.7739 15.8964 41.3523 19.2721 44.7279C22.6477 48.1036 27.2261 50 32 50ZM32 23C31.0648 23 30.3125 23.7523 30.3125 24.6875V32.5625C30.3125 33.4977 31.0648 34.25 32 34.25C32.9352 34.25 33.6875 33.4977 33.6875 32.5625V24.6875C33.6875 23.7523 32.9352 23 32 23ZM34.25 38.75C34.25 38.1533 34.0129 37.581 33.591 37.159C33.169 36.7371 32.5967 36.5 32 36.5C31.4033 36.5 30.831 36.7371 30.409 37.159C29.9871 37.581 29.75 38.1533 29.75 38.75C29.75 39.3467 29.9871 39.919 30.409 40.341C30.831 40.7629 31.4033 41 32 41C32.5967 41 33.169 40.7629 33.591 40.341C34.0129 39.919 34.25 39.3467 34.25 38.75Z"
              fill={fill}
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3622_10720">
          <rect width="64" height="64" fill="white" />
        </clipPath>
        <clipPath id="clip1_3622_10720">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
        <clipPath id="clip2_3622_10720">
          <rect
            width="36"
            height="36"
            fill="white"
            transform="translate(14 14)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Exclaimation;
